import React from 'react'
import "./Projects.css"
import ProjectList from './ProjectList'

function Projects() {

    const data = [
        {
            name: "Mern Stack Book Store",
            des: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old",
            projectlink: "",
            techused: [
                {
                    techname: "Node Js",

                },
                {
                    techname: "React Js",

                },
                {
                    techname: "Express Js",

                },
                {
                    techname: "Mongodb",

                }
            ]
        },

        {
            name: "Mern Stack Expense Tracker app",
            des: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old",
            projectlink: "",
            techused: [
                {
                    techname: "Node Js",

                },
                {
                    techname: "Ejs",

                },
                {
                    techname: "Express Js",

                },
                {
                    techname: "Mongodb",

                }
            ]
        },



        {
            name: "Mern Stack Portfolio website",
            des: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old",
            projectlink: "",
            techused: [
                {
                    techname: "Node Js",

                },
                {
                    techname: "Reac Js",

                },
                {
                    techname: "Express Js",

                },
                {
                    techname: "Mongodb",

                }
            ]
        },

        {
            name: "Flutter Todo app",
            des: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old",
            projectlink: "",
            techused: [
                {
                    techname: "Flutter",

                },
                {
                    techname: "Firebase",

                },
                {
                    techname: "Dart",

                },
                {
                    techname: "React js",

                }
            ]
        },
    ]
    return (
        <div className="container projects-section">
            <div className="section-titel">
                <h5>Projects</h5>
                <span className='line1'></span>
            </div>

            <div className='con'>
                <div className="row">

                    {data.map((item, index) => (
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12" key={index}>
                            <ProjectList {...item} />
                        </div>
                    ))}


                </div>
            </div>
        </div>
    )
}

export default Projects